import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormTextareaComponent } from '@pishgamrayan/ng-form-kit';
import { InlineSVGModule } from 'ng-inline-svg-2';

import { ShareDirectivesModule } from 'src/app/core/directives/directives.module';
import { TranslationModule } from 'src/app/i18n/translation.module';
import { ListGroupItemModule } from '../../global/list-group-item/list-group-item.module';
import { ModalTitleComponent } from '../../global/modal-title/modal-title.component';
import { MaterialModule } from '../../modules/material/material.module';
import { EmojiPickerComponent } from '../emoji-picker/emoji-picker.component';
import { FormFieldComponent } from '../form-kit/form-field/form-field.component';
import { SelectSearchModule } from '../select-search/select.search.module';
import { SmsBodyComponent } from '../sms-body/sms-body.component';
import { SmsTemplateModalModule } from '../sms-template-modal/sms-template-modal.module';
import { SeperateSmsBodyByPart } from './seperate-sms-body-by-part.pipe';
import { SmsBodyHeaderComponent } from './sms-body-header/sms-body-header.component';
import { SmsBodySignatureComponent } from './sms-body-signature/sms-body-signature.component';
import { SmsPreviewMobileComponent } from './sms-preview/mobile-preview/sms-preview-mobile.component';
import { BodyComponent } from './body/body.component';

@NgModule({
  declarations: [
    SmsBodyComponent,
    SmsBodySignatureComponent,
    SmsBodyHeaderComponent,
  ],
  exports: [
    SmsBodyComponent,
    SmsBodySignatureComponent,
    SmsBodyHeaderComponent,
  ],
  imports: [
    CommonModule,
    InlineSVGModule,
    MaterialModule,
    NgbModule,
    FormsModule,
    ShareDirectivesModule,
    EmojiPickerComponent,
    ReactiveFormsModule,
    TranslationModule,
    SmsTemplateModalModule,
    SelectSearchModule,
    ListGroupItemModule,
    SeperateSmsBodyByPart,
    SmsPreviewMobileComponent,
    FormFieldComponent,
    FormTextareaComponent,
    ModalTitleComponent,
    BodyComponent,
  ],
})
export class SmsBodyModule {}

